<template>
    <div
        :class="{
            'mobileHome zh-cn': lang === 'zh-cn',
            'mobileHome zh-cht': lang === 'zh-cht',
            'mobileHome en-us': lang === 'en-us',
            'mobileHome ja-jp': lang === 'ja-jp',
            'mobileHome ko-kr': lang === 'ko-kr',
        }"
        id="mobileHome"
    >
        <div class="topFixed">
            <div class="top">
                <div :class="navShow ? 'nav on' : 'nav'">
                    <span
                        class="nav-btn"
                        @click="
                            navShow = !navShow;
                            langNavShow = false;
                        "
                    >
                        <i></i>
                        <i></i>
                        <i></i>
                    </span>
                    <ul class="nav_ul">
                        <li
                            :class="navIndex == 1 ? 'on' : ''"
                            @click="link('m_1')"
                        >
                            <p>{{ langConfig.nav[0] }}</p>
                            <span></span>
                        </li>
                        <li
                            :class="navIndex == 2 ? 'on' : ''"
                            @click="link('m_2')"
                        >
                            <p>{{ langConfig.nav[1] }}</p>
                            <span></span>
                        </li>
                        <li
                            :class="navIndex == 3 ? 'on' : ''"
                            @click="link('m_3')"
                        >
                            <p>{{ langConfig.nav[2] }}</p>
                            <span></span>
                        </li>
                        <li
                            :class="navIndex == 4 ? 'on' : ''"
                            @click="link('m_4')"
                        >
                            <p>{{ langConfig.nav[3] }}</p>
                            <span></span>
                        </li>
                        <li
                            :class="navIndex == 5 ? 'on' : ''"
                            @click="link('m_5')"
                        >
                            <p>{{ langConfig.nav[4] }}</p>
                            <span></span>
                        </li>
                    </ul>
                </div>

                <h1 class="logo">
                    {{ langConfig.h1 }}
                </h1>
                <!-- <div :class="langNavShow? 'lang-nav on' : 'lang-nav'" @click="langNavShow = !langNavShow; navShow = false">
					<ul>
						<li :class="lang == 'zh-cn'? 'on' : ''"><a @click="setLang('zh-cn')">{{ langConfig.nav2[0] }}</a></li>
						<li :class="lang == 'zh-cht'? 'on' : ''"><a @click="setLang('zh-cht')">{{ langConfig.nav2[1] }}</a></li>
						<li :class="lang == 'en-us'? 'on' : ''"><a @click="setLang('en-us')">{{ langConfig.nav2[2] }}</a></li>
						<li :class="lang == 'ja-jp'? 'on' : ''"><a @click="setLang('ja-jp')">{{ langConfig.nav2[3] }}</a></li>
						<li :class="lang == 'ko-kr'? 'on' : ''"><a @click="setLang('ko-kr')">{{ langConfig.nav2[4] }}</a></li>
					</ul>
				</div> -->
            </div>
        </div>
        <div
            class="mian"
            @click="
                navShow = false;
                langNavShow = false;
            "
        >
            <div class="m m_1" id="m_1">
                <img src="@/assets/imgs/mobile/bg_1_3.jpg" width="100%" />
                <img src="@/assets/imgs/mobile/bg_1_3.png" width="100%" />
                <img src="@/assets/imgs/mobile/bg_1_1.png" width="100%" />
                <img
                    v-if="lang == 'zh-cn'"
                    src="@/assets/imgs/banner/bg_2_zh.png"
                />
                <img
                    v-else-if="lang == 'zh-cht'"
                    src="@/assets/imgs/banner/bg_2_cht.png"
                />
                <img v-else src="@/assets/imgs/banner/bg_2_en.png" />
                <div
                    class="m_1_icon"
                    @mouseover="m1iconShow = true"
                    @mouseout="m1iconShow = false"
                >
                    <div
                        class="m_1_icon_icon1 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    >
                        <span></span>
                        <span></span>
                    </div>
                    <div
                        class="m_1_icon_icon2 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    ></div>
                    <div
                        class="m_1_icon_icon3 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    ></div>
                </div>
            </div>
            <div class="m m_2" id="m_2">
                <div class="m_c m_2_c">
                    <div class="m_c_title m_2_c_title">
                        <span>{{ langConfig.m2.entitle }}</span>
                        <p>{{ langConfig.m2.title }}</p>
                    </div>
                    <div class="m_2_c_c">
                        <div class="m_2_c_c_t">
                            <div class="swiperC">
                                <img
                                    src="@/assets/imgs/mobile/pic/pic_1_2.jpg"
                                    width="100%"
                                    alt=""
                                />
                                <!-- <swiper :options="swiperOption" ref="mySwiper1"> -->
                                <!-- slides -->
                                <!-- <swiper-slide><img src="@/assets/imgs/mobile/pic/pic_1_2.jpg" alt="轮播图1"></swiper-slide> -->
                                <!-- <swiper-slide><img src="@/assets/imgs/mobile/pic/pic_1.jpg" alt="轮播图2"></swiper-slide>
									<swiper-slide><img src="@/assets/imgs/mobile/pic/pic_1.jpg" alt="轮播图3"></swiper-slide> -->
                                <!-- Optional controls -->
                                <!-- </swiper> -->
                            </div>
                        </div>
                        <div class="m_2_c_c_b">
                            <div class="m_2_c_c_b_title">
                                <p
                                    v-if="lang == 'en-us'"
                                    v-html="langConfig.m2.info11"
                                ></p>
                                <p v-else v-html="langConfig.m2.info1"></p>
                                <span>{{ langConfig.m2.info2 }}</span>
                            </div>
                            <div class="m_2_c_c_b_text">
                                <!-- <p v-html="langConfig.m2.info5"></p> -->
                                <p
                                    v-if="lang == 'en-us'"
                                    v-html="langConfig.m2.info5"
                                ></p>
                                <p v-else v-html="langConfig.m2.info3"></p>
                                <p v-html="langConfig.m2.info4"></p>
                                <!-- <a :href="langConfig.m2.info7" target="_blank">{{langConfig.m2.info6}}</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m m_3" id="m_3">
                <div class="m_c m_3_c">
                    <div class="m_c_title m_3_c_title">
                        <span>{{ langConfig.m3.entitle }}</span>
                        <p>{{ langConfig.m3.title }}</p>
                    </div>
                    <div class="m_3_c_c">
                        <div class="m_3_c_c_t">
                            <div class="swiperC">
                                <swiper
                                    :options="swiperOption2"
                                    ref="mySwiper1"
                                >
                                    <!-- slides -->
                                    <swiper-slide
                                        ><img
                                            src="@/assets/imgs/mobile/pic/pic_2_1.jpg"
                                            alt="轮播图1"
                                    /></swiper-slide>
                                    <swiper-slide
                                        ><img
                                            src="@/assets/imgs/mobile/pic/pic_2_2.jpg"
                                            alt="轮播图2"
                                    /></swiper-slide>
                                    <swiper-slide
                                        ><img
                                            src="@/assets/imgs/mobile/pic/pic_2_3.jpg"
                                            alt="轮播图3"
                                    /></swiper-slide>
                                    <swiper-slide
                                        ><img
                                            src="@/assets/imgs/mobile/pic/pic_2_5.jpg"
                                            alt="轮播图3"
                                    /></swiper-slide>
                                    <!-- Optional controls -->
                                </swiper>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                        <div class="m_3_c_c_b">
                            <div class="m_3_c_c_b_text">
                                <p v-html="langConfig.m3.info1"></p>
                                <p v-html="langConfig.m3.info2"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m m_4" id="m_4">
                <div class="m_c m_4_c">
                    <div class="m_c_title m_4_c_title">
                        <span>{{ langConfig.m4.entitle }}</span>
                        <p>{{ langConfig.m4.title }}</p>
                    </div>
                    <div class="m_4_c_c">
                        <ul>
                            <li
                                :class="
                                    m4show == 0 ? 'm_4_c_c_1 on' : 'm_4_c_c_1'
                                "
                                @mousemove="m4show = 0"
                                @mouseout="m4show = 1"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li1.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m4.li1.info2"></P>
                                </div>
                            </li>
                            <li
                                :class="
                                    m4show == 1 ? 'm_4_c_c_2 on' : 'm_4_c_c_2'
                                "
                                @mousemove="m4show = 1"
                                @mouseout="m4show = 1"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li2.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m4.li2.info }}</P> -->
                                    <P v-html="langConfig.m4.li2.info2"></P>
                                </div>
                            </li>
                            <li
                                :class="
                                    m4show == 2 ? 'm_4_c_c_3 on' : 'm_4_c_c_3'
                                "
                                @mousemove="m4show = 2"
                                @mouseout="m4show = 1"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li3.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m4.li3.info2"></P>
                                    <!-- <P>{{ langConfig.m4.li3.info }}</P> -->
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="m m_5" id="m_5">
                <div class="m_c m_5_c">
                    <div class="m_c_title m_5_c_title">
                        <span>{{ langConfig.m5.entitle }}</span>
                        <p>{{ langConfig.m5.title }}</p>
                    </div>
                    <div class="m_5_c_c">
                        <ul>
                            <li
                                :class="
                                    m5show == 0 ? 'm_5_c_c_1 on' : 'm_5_c_c_1'
                                "
                            >
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li1.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m5.li1.info2"></P>
                                </div>
                            </li>
                            <li
                                :class="
                                    m5show == 1 ? 'm_5_c_c_2 on' : 'm_5_c_c_2'
                                "
                            >
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li2.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m5.li2.info2"></P>
                                </div>
                            </li>
                            <li
                                :class="
                                    m5show == 2 ? 'm_5_c_c_3 on' : 'm_5_c_c_3'
                                "
                            >
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li3.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m5.li3.info2"></P>
                                </div>
                            </li>
                            <li
                                :class="
                                    m5show == 3 ? 'm_5_c_c_4 on' : 'm_5_c_c_4'
                                "
                            >
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li4.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m5.li4.info2"></P>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="m m_8" id="m_8">
                <div class="m_8_c">
                    <ul>
                        <li>
                            <a @click="link('m_3')">{{
                                langConfig.footNav[0]
                            }}</a>
                        </li>
                        |
                        <li>
                            <a @click="link('m_2')">{{
                                langConfig.footNav[2]
                            }}</a>
                        </li>
                        |
                        <li>
                            <a :href="langConfig.footLink1" target="_blank">{{
                                langConfig.footNav[3]
                            }}</a>
                        </li>
                        |
                        <li>
                            <a :href="langConfig.footLink2" target="_blank">{{
                                langConfig.footNav[4]
                            }}</a>
                        </li>
                    </ul>
                    <p>
                        {{ langConfig.footInfo }}<br />
                        {{ langConfig.footIcp }}<br />
                        {{ langConfig.footAddress }}<br />
                        {{ langConfig.footEmail2
                        }}<img src="../../assets/imgs/email.png" />
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { getPositionList } from "@/api";
import "@/assets/styles/index_pc.scss";
import Cookies from "js-cookie";
import langzhcn from "../pc/config/zh-cn.json";
import langzhhk from "../pc/config/zh-cht.json";
import langenus from "../pc/config/en-us.json";
import langjajp from "../pc/config/ja-jp.json";
import langkokr from "../pc/config/ko-kr.json";
import { GetRequest } from "@/utils";

// 防刷
import debounce from "lodash/debounce";

// 滚动条// 引入
var VueScrollTo = require("vue-scrollto");

export default {
    name: "mobileHome",
    components: {},
    data() {
        return {
            navIndex: 1,
            scroll: 0,
            lang: Cookies.get("lang") ? Cookies.get("lang") : "zh-cn",
            langNavShow: false,
            navShow: false,
            recruitInfo: [],
            m1iconShow: false,
            m4show: 1,
            m5show: 0,
            m4show2: 0,
            m6show: false,
            swiperOption: {
                // autoplay : 100,//可选选项，自动滑动
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                loop: true, //可选选项，开启循环
                grabCursor: true,
            },
            swiperOption2: {
                // autoplay : 100,//可选选项，自动滑动
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true, //可选选项，开启循环
                grabCursor: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            langConfig: langzhcn,
        };
    },
    watch: {
        scrollHeight(curVal, oldVal) {
            //普通的watch监听
            // console.log("scrollHeight: ", oldVal, curVal);
        },
    },
    mounted() {
        this.handleLoading();
        window.addEventListener("scroll", this.scrollDs, true);
        this.m4func();
    },
    methods: {
        /**
         * @function handleLoading 处理加载
         */
        async handleLoading() {
            console.log("初始化");
            // this.positionType()

            let urlRequest = GetRequest();
            console.log("urlRequest", urlRequest);
            console.log("urlRequest.navNum", urlRequest.navNum);
            switch (urlRequest.navNum) {
                case "1":
                    console.log("urlRequest1");
                    this.link("m_1");
                    break;
                case "2":
                    this.link("m_2");
                    break;
                case "3":
                    console.log("urlRequest4");
                    this.link("m_3");
                    break;
                case "4":
                    console.log("urlRequest4");
                    this.link("m_4");
                    break;
                case "5":
                    console.log("urlRequest5");
                    this.link("m_5");
                    break;
                default:
            }

            let url2 = window.location.pathname;
            let Dlang = process.env.VUE_APP_VERSION;
            console.log("url2: " + url2);
            console.log("Dlang: " + process.env.VUE_APP_VERSION);
            switch (Dlang) {
                case "zh":
                    this.lang = "zh-cn";
                    this.langConfig = langzhcn;
                    break;
                case "zh-cht":
                    this.lang = "zh-cht";
                    this.langConfig = langzhhk;
                    break;
                case "en":
                    this.lang = "en-us";
                    this.langConfig = langenus;
                    break;
                case "ja":
                    this.lang = "ja-jp";
                    this.langConfig = langjajp;
                    break;
                case "ko":
                    this.lang = "ko-kr";
                    this.langConfig = langkokr;
                    break;
                default:
            }

            // const cookieLang = Cookies.get('lang');
            // const browserLang = navigator.language.substring(0, 2);
            // console.log('browserLang', browserLang)
            // if (cookieLang) {
            // 	// this.setLang(cookieLang)
            // 	switch (cookieLang) {
            // 		case "zh-cn":
            // 			this.langConfig = langzhcn;
            // 		break;
            // 		case "zh-cht":
            // 			this.langConfig = langzhhk;
            // 		break;
            // 		case "en-us":
            // 			this.langConfig = langenus;
            // 		break;
            // 		case "ja-jp":
            // 			this.langConfig = langjajp;
            // 		break;
            // 		case "ko-kr":
            // 			this.langConfig = langkokr;
            // 		break;
            // 		default:
            // 	}
            // 	return
            // }
            // if (browserLang == 'zh') {
            // 	if (['zh-TW', 'zh-SG', 'zh-cht'].includes(browserLang2)) {
            // 		console.log('browserLang3', browserLang2)
            // 		this.setLang('zh-cht')
            // 		return
            // 	}
            // 	this.setLang('zh-cn')
            // 	return
            // }
            // if (browserLang == 'en') {
            // 	this.setLang('en-us')
            // 	return
            // }
            // if (browserLang == 'ko') {
            // 	this.setLang('ko-kr')
            // 	return
            // }
            // if (browserLang == 'ja') {
            // 	this.setLang('ja-jp')
            // 	return
            // }
            // console.log("Cookies.get('lang')", Cookies.get('lang'))
            // console.log("lang", this.lang)
            // this.setLang(this.lang)
        },

        /**
         * @function link 跳转位置
         */
        //js
        link(id) {
            VueScrollTo.scrollTo(document.getElementById(id), 1000, {
                offset: -70,
            });
            this.navShow = false;
        },

        /**
         * @function link 跳转位置
         */
        scrollDs() {
            this.navShow = false;
            this.langNavShow = false;
            this.scroll = document.documentElement.scrollTop;
            console.log("scroll", this.scroll);
            let m1 = document.getElementById("m_1").offsetTop - 110;
            let m2 = document.getElementById("m_2").offsetTop - 110;
            let m3 = document.getElementById("m_3").offsetTop - 110;
            let m4 = document.getElementById("m_4").offsetTop - 110;
            let m5 = document.getElementById("m_5").offsetTop - 110;
            if (this.scroll >= 0 && this.scroll < m1) {
                this.navIndex = 1;
            } else if (this.scroll >= m1 && this.scroll < m2) {
                this.navIndex = 1;
            } else if (this.scroll >= m2 && this.scroll < m3) {
                this.navIndex = 2;
            } else if (this.scroll >= m3 && this.scroll < m4) {
                this.navIndex = 3;
            } else if (this.scroll >= m4 && this.scroll < m5) {
                this.navIndex = 4;
            } else if (this.scroll >= m5 && this.scroll < 1800) {
                this.navIndex = 5;
            } else if (this.scroll >= 1800) {
                this.navIndex = 6;
            }
        },

        /**
         * @function setLang 设置语言
         */
        setLang(langType) {
            // Cookies.set('lang', langType)
            // console.log('langType', langType)
            this.lang = langType;
            // console.log('lang', this.lang)
            let url1 = window.location.host;
            let url2 = window.location.protocol;
            console.log("url1", url1);
            console.log("url2", url2);
            console.log("url3", url2 + "//" + url1 + "/zh/");
            switch (this.lang) {
                case "zh-cn":
                    // this.langConfig = langzhcn;
                    window.location.href = url2 + "//" + url1 + "/zh/";
                    break;
                case "zh-cht":
                    // this.langConfig = langzhhk;
                    window.location.href = url2 + "//" + url1 + "/zh-cht/";
                    break;
                case "en-us":
                    // this.langConfig = langenus;
                    window.location.href = url2 + "//" + url1 + "/en/";
                    break;
                case "ja-jp":
                    // this.langConfig = langjajp;
                    window.location.href = url2 + "//" + url1 + "/ja/";
                    break;
                case "ko-kr":
                    // this.langConfig = langkokr;
                    window.location.href = url2 + "//" + url1 + "/ko/";
                    break;
                default:
            }
        },

        /**
         * @function positionType 岗位类别
         */
        positionType() {
            getPositionList({ lang: "zh-cn", pageSize: 3, pageIndex: 1 })
                .then((res) => {
                    console.log("岗位类别成功", res);
                    console.log("岗位类别成功", res.data.list);
                    this.recruitInfo = res.data.list;
                })
                .catch((err) => {
                    console.log("岗位类别失败", err);
                });
        },

        /**
         * @function positionType 岗位类别
         */
        m4func() {
            this.m4show = this.m4show2 % 3;
            this.m5show = this.m4show2 % 4;
            this.m4show2++;
            setTimeout(() => {
                this.m4func();
            }, 3000);
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/styles/index_mobile.scss";
</style>
